define('modules/map/map_view',[
  'backbone',
  'jquery',
  '_',
  'URIjs/URI',
  './map_model',

  './map_overlay_item_view',

  'modules/loading/loading_spinner_view',

  'text!./map_template.html',
  'text!./map_image_template.html',
  'text!./map_player_item_template.html',

  'modules/modal/modal_view',
  './map_zone_picker_modal_view'
], function (Backbone, $, _,
             URI,
             MapModel,
             MapOverlayItemView,
             Loading,
             map_template,
             map_image_template,
             map_player_item_template,
             ModalView,
             MapZonePickerModalView) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {

      _.extend(this, opts);
      this.subViews = [];

      this.model = new MapModel();

      var loading = new Loading();
      this.subViews.push(loading);

      this.listenTo(this.model, 'request', loading.start.bind(loading));

      this.listenTo(this.model, 'sync', function (model) {
        loading.done();
        this.renderMap();

        if (model.get('has_map')) {
          this.renderList();
        }

      }, this);

      this.model.fetch();

      this.render();
    },

    template: _.template(map_template),
    map_template: _.template(map_image_template),
    player_item_template: _.template(map_player_item_template),

    overlayItemView: false,
    subViews: [],

    events: {
      'mouseover .player-link': 'mouseoverPlayer',
      'mouseout .player-link': 'mouseoutPlayer',
      'click .player-link': 'clickOnPlayer'
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderMap: function () {
      this.$('.js-map').prepend(this.map_template(this.model.toJSON()));
    },

    renderList: function () {
      var items = [];

      this.players_collection.each(function (model) {
        var x, y, obj;
        x = ( model.get('map_xpos') / this.model.get('width') ) * 100;
        y = ( model.get('map_ypos') / this.model.get('height') ) * 100;
        obj = _.extend(model.toJSON(), {position_top: y, position_left: x});
        items.push(this.player_item_template(obj));
      }, this);

      this.$('.js-map-players').html(items);

    },

    mouseoverPlayer: function (e) {
      var player_id = $(e.currentTarget).data('id'), player;
      player = this.players_collection.get(player_id);
      this.overlayItemView = new MapOverlayItemView({
        player: player,
        $el: this.$('.js-map-overlay')
      });
    },

    mouseoutPlayer: function (e) {
      this.overlayItemView.remove();
    },

    clickOnPlayer: function (e) {
      var player_id = $(e.currentTarget).data('id'), player;
      player = this.players_collection.get(player_id);

      if (player) {
        if (player.get('zones') && player.get('zones').length > 1) {
          this.showZonePickerModal(player);
        }
        else {
          window.location.href = '/players/' + player.get('player_id') + '?zone_id=' + player.get('zone_id');
        }
      }
    },

    showZonePickerModal: function (player) {

      var zonePickerModal = new ModalView({
        title: _.t('modal.header.map_zone_picker'),
        modalContent: new MapZonePickerModalView({
          player: player.toJSON()
        })
      });

      zonePickerModal.open();
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

